import React from "react"

import globalStyles from "../../../../App.module.scss";

export default function UsersAndGroups() {
    return (
        <div className={globalStyles.article}>
            <h1>Users &amp; groups management</h1>

            <p>User accounts are defined in <b>/etc/passwd</b>, their (hashed) passwords in <b>/etc/shadow</b>,
                and groups in <b>/etc/group</b>. Both files can be edited directly with <code>vipw</code>/<code>vigr</code>,
                but the commands below are safer.</p>

            <h3>Creating &amp; editing users</h3>
            <pre className={globalStyles.code}>
    <b>root@host:~#</b> useradd -m -s /bin/bash -G sudo,docker julian <i># -m creates home dir</i><br/>
    <b>root@host:~#</b> passwd julian<br/>
    <b>root@host:~#</b> usermod -aG docker julian <i># -a appends, without it groups are overwritten</i><br/>
    <b>root@host:~#</b> usermod -L julian <i># lock the account</i><br/>
    <b>root@host:~#</b> userdel -r julian <i># -r also removes the home directory</i><br/>
            </pre>

            <h3>Groups</h3>
            <pre className={globalStyles.code}>
    <b>root@host:~#</b> groupadd deployers<br/>
    <b>root@host:~#</b> gpasswd -a julian deployers <i># add user to group</i><br/>
    <b>root@host:~#</b> gpasswd -d julian deployers <i># remove user from group</i><br/>
    <b>user@host:~$</b> groups julian<br/>
    <b>user@host:~$</b> id julian<br/>
            </pre>

            <h3>/etc/passwd fields</h3>
            <pre className={globalStyles.code}>julian:x:1001:1001:Julian Capilla:/home/julian:/bin/bash</pre>

            <div className={globalStyles.styledTable}>
                <table style={{minWidth: '330px'}}>
                    <thead>
                    <tr>
                        <th colSpan="2">Field breakdown</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><b>julian</b></td>
                        <td>Username</td>
                    </tr>
                    <tr>
                        <td><b>x</b></td>
                        <td>Password placeholder — real hash lives in /etc/shadow</td>
                    </tr>
                    <tr>
                        <td><b>1001</b></td>
                        <td>UID (user id)</td>
                    </tr>
                    <tr>
                        <td><b>1001</b></td>
                        <td>GID (primary group id)</td>
                    </tr>
                    <tr>
                        <td><b>Julian Capilla</b></td>
                        <td>GECOS / comment field</td>
                    </tr>
                    <tr>
                        <td><b>/home/julian</b></td>
                        <td>Home directory</td>
                    </tr>
                    <tr>
                        <td><b>/bin/bash</b></td>
                        <td>Login shell</td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <p><b>/etc/shadow</b> stores the hashed password plus password-aging fields: last change, minimum/maximum
                age, warning period and expiration date, all in days since 1970-01-01.</p>

            <pre className={globalStyles.code}>
    <b>root@host:~#</b> chage -l julian <i># show password aging info</i><br/>
    <b>root@host:~#</b> chage -M 90 julian <i># force password change every 90 days</i><br/>
            </pre>
        </div>
    )
}
